export const itemIds = [
  {
    name: "Home",
    slug: "/",
  },
  {
    name: "All Posts",
    slug: "/posts",
  },
  {
    name: "Courses",
    slug: "/course",
  },
  {
    name: "Internship",
    slug: "/internship",
  },
]
